import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import dayjs from "dayjs";
import { useNavigate } from "react-router-dom";
import dashboardActions from "../../../redux/dashboard/actions";
import { useProjectState } from "../../../context/stateContext";
import DashboardOpenCloseWidget from "../../../components/User/DashboardComponents/DashboardOpenCloseWidget";
import TurnoverChart from "../../../components/User/DashboardComponents/TurnoverChart";
import DashboardAreasPie from "../../../components/User/DashboardComponents/DashboardAreasPie";
import "./index.css";
import areasActions from "../../../redux/areas/actions";
import DashboardAreasChart from "../../../components/User/DashboardComponents/DashboardAreasChart";
import redirectIcon from "../../../assets/images/redirectIcon.png";
import PageHeader from "../../../components/Common/PageHeader/PageHeader";
import DashboardHeader from "../../../components/User/DashboardComponents/DashboardHeader";

const {
  getTablesOverview,
  getDailyTurnOver,
  getDailyTurnoverForPast8DaysByRestaurants,
} = dashboardActions;

const { getAreas, getTurnOverByAreas } = areasActions;

const Dashboard = () => {
  const navigate = useNavigate();
  const { areasTurnOver, areas } = useSelector((state) => state.areasReducer);
  const { organizations } = useSelector(
    (state) => state.getOrganizationAndRestaurantReducer
  );
  const { selectedOrganization } = useProjectState();

  const { tablesOverview, dailyTurnOver, dailyTurnoverForPast8Days } =
    useSelector((state) => state.dashboardReducer);
  const dispatch = useDispatch();
  const currentDay = dayjs().format("YYYY-MM-DD");

  const filteredIds = areas.map((item) => item.id);

  const defaultOrganization = organizations.filter(
    (itemInArray) => itemInArray.id === selectedOrganization
  );
  const defaultTouchSaleRestaurantId =
    defaultOrganization[0]?.defaultTouchSaleRestaurantId;
  useEffect(() => {
    if (defaultOrganization.length > 0) {
      dispatch(getTablesOverview());
      dispatch(getDailyTurnOver(currentDay, currentDay));
      dispatch(getDailyTurnoverForPast8DaysByRestaurants());
      dispatch(
        getAreas(defaultOrganization[0]?.defaultTouchSaleRestaurantId, false)
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedOrganization, defaultTouchSaleRestaurantId]);

  useEffect(() => {
    if (areas.length !== 0) {
      dispatch(getTurnOverByAreas(filteredIds, currentDay, currentDay));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [areas]);

  const memoizedTurnoverChart = useMemo(() => {
    if (
      dailyTurnoverForPast8Days.length !== 0 &&
      dailyTurnoverForPast8Days.length !== 1 &&
      dailyTurnoverForPast8Days[0] !== undefined
    ) {
      const rows = [];
      const row = [];

      row.push(
        dailyTurnoverForPast8Days.map((diagram, index) => (
          <TurnoverChart key={index} dataTurnOver={diagram} />
        ))
      );
      rows.push(
        <div
          className="dashboard-turnonver-diagram-row"
          key="dashboard-turnonver-diagram-row"
        >
          {row}
        </div>
      );

      return rows;
    } else if (
      dailyTurnoverForPast8Days.length === 1 &&
      dailyTurnoverForPast8Days[0] !== undefined
    ) {
      return (
        <TurnoverChart
          key="one-diagram"
          dataTurnOver={dailyTurnoverForPast8Days[0]}
        />
      );
    }
    return null;
  }, [dailyTurnoverForPast8Days]);

  const checkForValues = () => {
    for (let i = 0; i < areasTurnOver.length; i++) {
      if (areasTurnOver[i].total !== 0) {
        return true;
      }
    }
    return false;
  };

  return (
    <div>
      <div className="dashboard-titles-container">
        <PageHeader text="Информация за текущи Отворени/Затворени Маси" />
        <img
          id="action-button"
          src={redirectIcon}
          onClick={() => navigate("/tables")}
          alt="background"
          width="20px"
          height="20px"
        />
      </div>

      <DashboardOpenCloseWidget
        dailyTurnOver={dailyTurnOver}
        openTables={tablesOverview}
      />
      {areasTurnOver.length !== 0 && checkForValues() && (
        <>
          <div
            className="dashboard-titles-container"
            style={{ marginTop: "40px" }}
          >
            <DashboardHeader text="Обороти по обекти" />
            <img
              id="action-button"
              src={redirectIcon}
              onClick={() => navigate("/areas")}
              alt="background"
              width="20px"
              height="20px"
            />
          </div>

          <div className="areas-container">
            <div className="areas-pie">
              <DashboardAreasPie />
            </div>
            <div className="areas-chart">
              <DashboardAreasChart />
            </div>
          </div>
        </>
      )}
      {memoizedTurnoverChart}
    </div>
  );
};

export default Dashboard;
